import { supabase } from '@/integrations/supabase/client';

// Global debugging function for authentication and cart state
export const debugAuthAndCart = async () => {
  console.log('🔍 =========================');
  console.log('🔍 AUTHENTICATION & CART DEBUG');
  console.log('🔍 =========================');
  
  // Check current auth session
  const { data: { session }, error } = await supabase.auth.getSession();
  
  if (error) {
    console.error('❌ Error getting session:', error);
  }
  
  console.log('👤 User Info:');
  console.log('  - User ID:', session?.user?.id || 'Not logged in');
  console.log('  - Email:', session?.user?.email || 'Not logged in');
  console.log('  - Session expires:', session?.expires_at ? new Date(session.expires_at * 1000).toLocaleString() : 'N/A');
  
  // Check localStorage for user data
  console.log('\n📦 localStorage Data:');
  const relevantKeys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (
      key.includes('cart') || 
      key.includes('user') || 
      key.includes('profile') ||
      key.includes('supabase') ||
      key.includes('auth') ||
      key.includes('favorites')
    )) {
      relevantKeys.push(key);
    }
  }
  
  if (relevantKeys.length > 0) {
    relevantKeys.forEach(key => {
      const value = localStorage.getItem(key);
      if (key.includes('cart')) {
        try {
          const cartData = JSON.parse(value || '[]');
          console.log(`  - ${key}: ${cartData.length} items`);
        } catch {
          console.log(`  - ${key}: ${value?.substring(0, 50)}...`);
        }
      } else {
        console.log(`  - ${key}: ${value?.substring(0, 50)}${value && value.length > 50 ? '...' : ''}`);
      }
    });
  } else {
    console.log('  - No relevant data found');
  }
  
  // Check sessionStorage
  console.log('\n🗂️  sessionStorage Data:');
  const sessionKeys = [];
  if (typeof sessionStorage !== 'undefined') {
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && (
        key.includes('cart') || 
        key.includes('user') || 
        key.includes('supabase') ||
        key.includes('auth')
      )) {
        sessionKeys.push(key);
      }
    }
    
    if (sessionKeys.length > 0) {
      sessionKeys.forEach(key => {
        const value = sessionStorage.getItem(key);
        console.log(`  - ${key}: ${value?.substring(0, 50)}${value && value.length > 50 ? '...' : ''}`);
      });
    } else {
      console.log('  - No relevant data found');
    }
  }
  
  console.log('\n🔍 =========================');
  console.log('💡 To test cart bleeding:');
  console.log('1. Login as User 1, add items to cart');
  console.log('2. Call debugAuthAndCart() - note User ID and cart');
  console.log('3. Logout completely');
  console.log('4. Call debugAuthAndCart() - verify cart is empty');
  console.log('5. Login as User 2');
  console.log('6. Call debugAuthAndCart() - verify different User ID and empty cart');
  console.log('🔍 =========================');
  
  return {
    authenticated: !!session?.user,
    userId: session?.user?.id,
    email: session?.user?.email,
    localStorageKeys: relevantKeys.length,
    sessionStorageKeys: sessionKeys.length
  };
};

// Make it available globally for console debugging
if (typeof window !== 'undefined') {
  (window as any).debugAuthAndCart = debugAuthAndCart;
}